import React, { useState } from 'react';

const DeclineInvitationModal = ({ 
  isOpen, 
  onClose, 
  onDecline, 
  loading, 
  invitation, 
  applicationData 
}) => {
  const [declineReason, setDeclineReason] = useState('');

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('uk-UA');
  };

  const handleDecline = async () => {
    if (!declineReason.trim()) {
      alert('Будь ласка, вкажіть причину відхилення');
      return;
    }

    try {
      await onDecline(declineReason);
      setDeclineReason('');
    } catch (error) {
      // Ошибка обрабатывается в родительском компоненте
    }
  };

  const handleClose = () => {
    setDeclineReason('');
    onClose();
  };

  if (!isOpen || !invitation) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="application-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <div className="modal-header">
          <h2 className="modal-title">Відхилення запрошення</h2>
          <button className="close-button" onClick={handleClose}>×</button>
        </div>

        <div className="modal-content">
          <div className="data-section">
            <div className="data-row">
              <label className="data-label">Дитина:</label>
              <span className="data-value">
                {applicationData.childLastName} {applicationData.childFirstName} {applicationData.childMiddleName}
              </span>
            </div>
            
            <div className="data-row">
              <label className="data-label">Дитячий заклад:</label>
              <span className="data-value">{invitation.kindergartenName} {invitation.kindergartenNumber}</span>
            </div>
            
            <div className="data-row">
              <label className="data-label">Група:</label>
              <span className="data-value">{invitation.groupNumber}</span>
            </div>
            
            <div className="data-row">
              <label className="data-label">Тип місця:</label>
              <span className="data-value">{invitation.placeType || 'Повного дня'}</span>
            </div>
            
            <div className="data-row">
              <label className="data-label">Термін дії запрошення:</label>
              <span className="data-value">
                {invitation.dateTo ? formatDateTime(invitation.dateTo) : 'Не вказано'}
              </span>
            </div>
            
            <div className="comment-field" style={{ marginTop: '16px' }}>
              <label htmlFor="decline-reason" className="comment-label">
                Причина відхилення:
              </label>
              <textarea
                id="decline-reason"
                className="form-control comment-textarea"
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
                placeholder="Вкажіть причину відхилення запрошення..."
                rows="4"
              />
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <div className="action-buttons">
            <button 
              className="btn btn-danger"
              onClick={handleDecline}
              disabled={loading || !declineReason.trim()}
            >
              {loading ? 'Обробка...' : 'Відхилити'}
            </button>
          </div>
          <button 
            className="btn btn-secondary" 
            onClick={handleClose}
            disabled={loading}
          >
            Закрити
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclineInvitationModal;